import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  loading: false,
  categories: [],
  error: "",
  selectedCategories: [],
};

export const getCategories = createAsyncThunk(
  "category/getCategories",
  async (_, thunkApi) => {
    const { rejectWithValue, dispatch } = thunkApi;
    try {
      const res = await axios.get("product/api/v1/categories-bulk/");

      const data = res.data;
      const categoriesWithNoCategory = [
        ...data,
        { id: 0, name: "no category" },
      ];

      return categoriesWithNoCategory;
    } catch (error) {
      console.log("error from admin slice", error);
      if (error.response?.status === 401) {
        dispatch("admin/refresh");
      }
      return rejectWithValue(error.message);
    }
  },
);

const categorySlice = createSlice({
  name: "category",
  initialState: initialState,
  reducers: {
    setSelectedCategories(state, action) {
      state.selectedCategories = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCategories.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getCategories.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.categories = action.payload;
    });
    builder.addCase(getCategories.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { setSelectedCategories } = categorySlice.actions;
export default categorySlice.reducer;
